const SCREENSIZE = {
    'xsmall': 'xsmall',
    'small': 'small',
    'medium': 'medium',
    'large': 'large',
  };

export default SCREENSIZE;
